export default __webpack_public_path__ + "static/media/1552.4724b93d.png";